import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
// @ts-expect-error untyped dependency
import providerSignupImageUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-image.png'; // @ts-expect-error untyped dependency

import providerSignupBlobsUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-blobs.png';
import { getPublicAssetProviderSignupUrl } from '../../utils/urls';
export default function ProviderSignupBanner({
  onTrackInteraction
}) {
  const containerRef = useRef(null);
  const leftColumnRef = useRef(null);
  const [compact, setCompact] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const handleSetResponsiveStyles = useCallback(() => {
    if (containerRef.current) {
      if (containerRef.current.clientWidth >= 1100) {
        setCompact(false);
      } else {
        setCompact(true);
      }
    }

    if (leftColumnRef.current) {
      setContainerHeight(leftColumnRef.current.clientHeight);
    }
  }, [containerRef, leftColumnRef]);
  useLayoutEffect(() => {
    window.addEventListener('resize', handleSetResponsiveStyles);
    handleSetResponsiveStyles();
    return () => window.removeEventListener('resize', handleSetResponsiveStyles);
  }, [handleSetResponsiveStyles]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    ref: containerRef,
    style: {
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: "m-right-3  p-x-10 p-top-10",
      direction: "column",
      ref: leftColumnRef,
      style: {
        paddingBottom: 100
      },
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.providerSignupCTA.title"
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "is--heading-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.providerSignupCTA.subtitle"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-4",
        onClick: () => {
          onTrackInteraction('click provider signup');
        },
        href: getPublicAssetProviderSignupUrl(),
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.providerSignupCTA.button"
        })
      })]
    }), !isMobileView && /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        height: containerHeight,
        position: 'relative',
        width: '50%'
      },
      children: [/*#__PURE__*/_jsx(UIImage, {
        height: containerHeight,
        responsive: false,
        src: providerSignupImageUrl,
        style: {
          position: 'absolute',
          top: 0,
          right: 'auto'
        }
      }), /*#__PURE__*/_jsx(UIImage, {
        height: 124,
        responsive: false,
        src: providerSignupBlobsUrl,
        style: {
          position: 'absolute',
          bottom: 0,
          left: compact ? -240 : -312
        }
      })]
    })]
  });
}